import { Menu } from "lucide-react";
import { Link } from "react-router-dom";
import { useState } from "react";

import { Button } from "../ui/button";
import { Sheet, SheetClose, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "../ui/sheet";
import WhatsNewLink from "./WhatsNewLink";
import {
  ADMIN_ITEMS,
  ANNUAL_REPORTS_ITEMS,
  INSTRUCTIONS_PLUGINS_ITEMS,
  LEAD_VIEWS_ITEMS,
  SCORING_FILTERS_ITEMS,
} from "./utils";

const MobileNavigation = ({ hasUnreadNews }: { readonly hasUnreadNews: boolean }) => {
  const [open, setOpen] = useState(false);

  const navigationItems = [
    { type: "single" as const, href: "/pluto", title: "Pluto" },
    { type: "single" as const, href: "/", title: "Companies" },
    { type: "single" as const, href: "/domains", title: "Domains" },
    { type: "menu" as const, title: "Lead views", menuItems: LEAD_VIEWS_ITEMS },
    { type: "single" as const, href: SCORING_FILTERS_ITEMS[0]!.href, title: SCORING_FILTERS_ITEMS[0]!.title },
    { type: "menu" as const, title: "Annual Reports", menuItems: ANNUAL_REPORTS_ITEMS },
    { type: "menu" as const, title: "Instructions / Plugins", menuItems: INSTRUCTIONS_PLUGINS_ITEMS },
    { type: "menu" as const, title: "Admin", menuItems: ADMIN_ITEMS },
  ];

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetTrigger asChild>
        <Button variant="ghost" size="icon" className="xl:hidden" aria-label="Open navigation menu">
          <Menu className="h-6 w-6" />
        </Button>
      </SheetTrigger>
      <SheetContent side="left" className="w-[300px] sm:w-[400px]">
        <SheetHeader>
          <SheetTitle className="text-justify pt-3 pl-3 text-4xl font-bold text-stone-900">Navigation</SheetTitle>
        </SheetHeader>
        <div className="mt-4 space-y-2">
          <SheetClose asChild>
            <WhatsNewLink
              hasUnread={hasUnreadNews}
              className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
            />
          </SheetClose>
          {navigationItems.map((item) => {
            if (item.type === "single") {
              return (
                <SheetClose asChild key={item.title}>
                  <Link
                    to={item.href}
                    className="block w-full rounded-md px-3 py-2 text-sm font-medium transition-colors hover:bg-accent hover:text-accent-foreground"
                  >
                    {item.title}
                  </Link>
                </SheetClose>
              );
            }

            return (
              <div key={item.title} className="space-y-2">
                <div className="px-3 text-sm font-semibold text-muted-foreground">{item.title}</div>
                <div className="ml-3 space-y-1">
                  {item.menuItems.map((menuItem) => (
                    <SheetClose asChild key={menuItem.title}>
                      <Link
                        to={menuItem.href}
                        className="flex items-start gap-3 rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent hover:text-accent-foreground"
                      >
                        <div className="mt-0.5 flex-shrink-0">{menuItem.icon}</div>
                        <div className="flex-1">
                          <div className="font-medium leading-none">{menuItem.title}</div>
                          <p className="mt-1 text-xs text-muted-foreground">{menuItem.description}</p>
                        </div>
                      </Link>
                    </SheetClose>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </SheetContent>
    </Sheet>
  );
};

export default MobileNavigation;
